<template>
    <div
        class="fullwidth-wrapper__content"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
        @mousemove="handleMouseMove"
        @mouseleave="handleMouseLeave"
    >
        <table class="match-table match-table--traits">
            <thead>
                <tr>
                    <th></th>
                    <th class="match-table__header-cell">
                        <div class="person-circle person-circle--large match-table__person-circle">
                            {{ currentUser.fname.substring(0, 2) }}
                        </div>
                        <span class="match-table__person-name">{{ currentUser.fname.toLowerCase() }}</span>
                    </th>
                    <th
                        class="match-table__header-cell"
                        v-for="(person, index) in circleMembers"
                        :key="`person-id-${index}`">
                        <router-link
                            class="match-table__header-cell-button button--transparent"
                            :to="{
                                name: 'profiling',
                                params: {
                                    partnerId: person.id
                                }
                            }">
                            <div class="person-circle person-circle--large match-table__person-circle">
                                {{ person.name.substring(0, 2) }}
                            </div>
                            <span class="match-table__person-name">{{ person.name.toLowerCase() }}</span>
                        </router-link>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="match-table__score">
                    <td class="match-table__body-cell">{{ $t("ranking") }}</td>

                    <td class="match-table__body-cell"></td>

                    <td
                        class="match-table__body-cell"
                        v-for="(person, index) in circleMembers"
                        :key="`person-score-${index}`">
                        {{ person.distance }}
                    </td>
                </tr>
                <tr
                    class="match-table__row"
                    v-for="(trait, indextraits) in userPrimaryTraits"
                    :key="`trait-${indextraits}`">
                    <td class="match-table__body-cell">{{ $t(trait.traits) }}</td>
                    <td
                        class="match-table__body-cell">
                        <button
                            @click="openDetailModal(trait)"
                            type="button"
                            class="trait-circle button--trait-circle button--transparent"
                            :style="`background-color: #${trait.color}; width: ${trait.points_perc * baseCircleDiameter}px; height: ${trait.points_perc * baseCircleDiameter}px;`">
                        </button>
                    </td>
                    <td
                        class="match-table__body-cell"
                        v-for="(person, indexPerson) in circleMembersActiveTraits"
                        :key="`person-traits-${indexPerson}`">

                        <button
                            v-if="person[indextraits]"
                            @click="openDetailModal(person[indextraits])"
                            type="button"
                            class="trait-circle button--trait-circle button--transparent"
                            :style="`background-color: #${person[indextraits].color}; width: ${getTraitDiameter(person[indextraits].points_perc)}px; height: ${getTraitDiameter(person[indextraits].points_perc)}px;`">
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <trait-detail-modal
            v-if="isDetailModalVisible"
            :current-trait-detail="selectedTraitDetail"
            :display-score="displayScore"
            :current-trait="selectedTrait"
            @closeModal="closeDetailModal"
            :current-user-score="currentUserScore">
        </trait-detail-modal>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

import TraitDetailModal from "@/components/modals/traits/TraitDetailModal.vue";

import { capitalize } from "@/utils/helpers/string.js";

export default {
    name: "MatchTraitsTable",
    components: {
        "TraitDetailModal": TraitDetailModal
    },
    props: {
        groupTraits: {
            type: Array,
            required: true
        },
        currentUser: {
            type: Object,
            required: true
        },
        currentType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            traitsData: null,
            baseCircleDiameter: 2,
            isDetailModalVisible: false,
            selectedTraitDetail: null,
            selectedTrait: null,
            displayScore: null,
            currentUserScore: 0,
            x: 0,
            y: 0,
            top: 0,
            left: 0,
            isMouseDown: false,
            isDragEnable: false
        };
    },
    computed: {
        currentUserDominante() {
            switch (this.currentType) {
            case "resemblance":
            case "reversed-attraction":
                return "Perso";
            case "attraction":
                return "Recherchées";
            }
        },
        otherUsersDominante() {
            switch (this.currentType) {
            case "resemblance":
            case "attraction":
                return "Perso";
            case "reversed-attraction":
                return "Recherchées";
            }
        },
        compareType() {
            switch (this.currentType) {
            case "resemblance":
                return "samesame";
            case "attraction":
                return "attractedTo";
            case "reversed-attraction":
                return "reversedAttractedTo";
            }
        },
        titles() {
            if (this.currentPeoples) {
                switch (this.currentType) {
                case "resemblance":
                    return [
                        this.$t("same-is-like-you", {x: capitalize(this.currentPeoples[1].name)}),
                        this.$t("same-is-unlike-you", {x: capitalize(this.currentPeoples[this.currentPeoples.length - 1].name)})
                    ];
                case "attraction":
                    return [
                        this.$t("attraction-you-attracted-to", {x: capitalize(this.currentPeoples[1].name)})
                    ];
                case "reversed-attraction":
                    return [
                        this.$t("attraction-is-attracted-to-you", {x: capitalize(this.currentPeoples[1].name)})
                    ];
                default:
                    return false;
                }
            }

            return;
        },
        // currentTraits
        // Filtered list of traits based on report_name = me_friends
        currentTraits() {
            const traits = this.groupTraits.filter((trait) => {
                if (trait.report_name !== "me_friends") {
                    return false;
                }

                return true;
            });

            return traits;
        },
        // currentRanking
        // Ordered array of each traits based on ranking
        currentRanking() {
            if (this.groupTraits) {

                // gets all traits for the ranking of current type
                const ranking = this.groupTraits.filter((trait) => {

                    if (trait.report_name !== "match_friends") {
                        return false;
                    }

                    if (trait.compare && trait.compare !== this.compareType) {
                        return false;
                    }


                    if (trait.id_person !== this.currentUser.id_person) {
                        return false;
                    }

                    return true;
                });

                if (ranking && ranking.length > 0) {
                    // Sort descending (the higher the ranking the closest to the user, e.g 3 is closer than 1)
                    const orderedRanking = ranking.sort((a, b) => {
                        return parseFloat(b.ranking) - parseFloat(a.ranking);
                    });

                    return orderedRanking;
                }
            }

            return;
        },
        // currentPeoples
        // List of single person present in the lists of traits
        currentPeoples() {
            if (this.currentTraits && this.currentTraits.length > 0 && this.currentRanking && this.currentRanking.length > 0) {

                let peoples = this.currentTraits.reduce((peoplesArray, trait) => {
                    const id = trait["id_person"];
                    const name = trait["name"];

                    if (!peoplesArray[id]) {
                        // get the real rank of the current person (based in the order of this.currentRanking)
                        // first entry of this.currentRanking, is the closer.
                        const personRank = this.getObjetIndexByKey(this.currentRanking, "same_id_person", id);

                        peoplesArray[id] = {
                            "id": id,
                            "name": name,
                            "ranking": personRank,
                            "distance": (personRank > -1) ? this.currentRanking[personRank].distance : "",
                            "traits": []
                        };
                    }

                    peoplesArray[id].traits.push(trait);

                    return peoplesArray;
                }, {});


                if (peoples[this.currentUser.id_person]) {
                    const cleanedPeoples = Object.values(peoples);

                    const orderedPeoples = cleanedPeoples.sort((a, b) => {
                        return parseFloat(a.ranking) - parseFloat(b.ranking);
                    });

                    return orderedPeoples;
                }

            }

            return;
        },
        // userTraits
        // List of traits of the currentUser for a given dominantes (id_person) (based on previously filtered currentTraits)
        userTraits() {
            if (this.currentTraits) {
                const traits = this.currentTraits.filter((trait) => {
                    if (trait.id_person !== this.currentUser.id_person) {
                        return false;
                    }

                    if (trait.dominantes !== this.currentUserDominante) {
                        return false;
                    }

                    return true;
                });

                return traits;
            }

            return;
        },
        // userPrimaryTraits
        // List of non null primary (type QQ) (should always be 5)
        userPrimaryTraits() {
            if (this.userTraits) {
                const traits = this.userTraits.filter((trait) => {

                    if (trait.type !== "QQ") {
                        return false;
                    }

                    if (trait.points_perc === 0) {
                        return false;
                    }

                    return true;
                });

                return traits;
            }
        },
        // List of person whitout the current user,
        // The traits of each person is also altered to only include the 'perso' dominantes
        circleMembers() {
            if (this.currentPeoples) {
                const members = this.currentPeoples.filter((member) => {
                    if (member.id !== this.currentUser.id_person) {
                        return true;
                    }

                    return false;
                });

                return members.map((member) => {
                    // Modify member traits to only keep the one with 'otherUsersDominante' as dominantes
                    let updatedMember = member;

                    updatedMember.traits = member.traits.filter((trait) => {
                        if (trait.dominantes !== this.otherUsersDominante) {
                            return false;
                        }

                        return true;
                    });

                    return updatedMember;
                });
            }
        },
        // circleMembersActiveTraits
        // Filtered array containing only the traits present in userPrimaryTraits for currentPeoples
        circleMembersActiveTraits() {
            if (this.userPrimaryTraits) {
                return this.circleMembers.map((person) => {

                    return this.userPrimaryTraits.map((trait) => {

                        const traitIndex = this.getObjetIndexByKey(person.traits, "traits", trait.traits);

                        if (traitIndex > -1) {
                            return person.traits[traitIndex];
                        } else {
                            return null;
                        }
                    });
                });
            }
        }
    },
    watch: {
        titles (value) {
            this.updateSubtitle(value);
        }
    },
    mounted() {
        this.fetchTraitDetailData();
        this.updateSubtitle(this.titles);
    },
    methods: {
        handleMouseUp() {
            this.isMouseDown = false;
        },
        handleMouseDown() {
            this.isMouseDown = true;
            this.y = event.pageY;
            this.x = event.pageX;
            this.top = this.$el.parentNode.scrollTop;
            this.left = this.$el.parentNode.scrollLeft;
        },
        handleMouseMove(event) {
            this.isDragEnable = true;
            if (this.isDragEnable && this.isMouseDown) {
                this.$el.parentNode.scrollLeft = this.left - event.pageX + this.x;
                this.$el.parentNode.scrollTop = this.top - event.pageY + this.y;
            }
        },
        handleMouseLeave() {
            this.isDragEnable = false;
        },
        getTraitDiameter(value) {
            let roundedDiameter = Math.round(value * this.baseCircleDiameter);

            if (roundedDiameter % 2 !== 0) {
                roundedDiameter += 1;
            }

            return roundedDiameter;
        },
        fetchTraitDetailData () {
            const currentLocal = this.$i18n.locale;

            axios({
                url: `/json/traits/traits-detail.${currentLocal}.json`,
            }).then(res => {
                this.traitsData = res.data;
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
        openDetailModal(trait) {
            if (trait.id_person === this.currentUser.id_person) {
                this.displayScore = trait.points_perc;
                this.currentUserScore = trait.points_perc;
            } else {


                const currentUserTrait = this.userTraits.find((element) => {
                    if (element.traits !== trait.traits) {
                        return false;
                    }


                    return true;
                });

                // Relative score
                this.displayScore = trait.points_perc;
                this.currentUserScore = 0;
            }

            this.selectedTrait = trait;
            this.selectedTraitDetail = this.traitsData[trait.traits];

            this.isDetailModalVisible = true;
        },
        closeDetailModal() {
            this.isDetailModalVisible = false;
        },
        updateSubtitle(value) {
            this.$emit("update-subtitle", value);
        }
    }
};
</script>

